// 4-конечная звезда бренда с тёплым градиентом (блик слева-сверху → янтарь).
// Используется в sidebar, mobile-drawer, topbar и как accent в nav-итемах.
import { useId } from "react";

export function BrandSparkle({ size = 20 }: { size?: number }) {
	const uid = useId();
	const gradId = `brand-sparkle-${uid}`;
	return (
		<svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
			<defs>
				<linearGradient id={gradId} x1="20%" y1="15%" x2="85%" y2="90%">
					<stop offset="0%" stopColor="#FFF6C2" />
					<stop offset="45%" stopColor="#FFD24A" />
					<stop offset="100%" stopColor="#F2A93B" />
				</linearGradient>
			</defs>
			<path
				d="M21 12c-6.597 0 -9 2.403 -9 9c0 -6.597 -2.403 -9 -9 -9c6.597 0 9 -2.403 9 -9c0 6.597 2.403 9 9 9"
				fill={`url(#${gradId})`}
				stroke="none"
			/>
		</svg>
	);
}
